import { render, staticRenderFns } from "./ReportSessionDetailEmail.vue?vue&type=template&id=67f2717c"
import script from "./ReportSessionDetailEmail.vue?vue&type=script&lang=js"
export * from "./ReportSessionDetailEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports